import React from 'react';

import { Loader } from '@/components/loader/loader';
import { useResponseLogsQuery } from '@/hooks/queries/useLogs';
import type { PlaygroundLog, RequestLog } from '@/types/logs';

import ActionLogDetailView from './actionLogDetailView';
import ModelLogDetailView from './modelLogDetailView';
import ResponseLogDetailView from './responseLogDetailView';

type Props = {
  log: PlaygroundLog;
};

const RequestLogDetail = ( { log }: { log: RequestLog } ) => {
  const callId = log.meta_data?.call_id ?? null;
  const { data, isLoading } = useResponseLogsQuery( callId );
  const responses = data?.completion_responses ?? [];

  if( isLoading ) {
    return <Loader />;
  }

  return <ResponseLogDetailView request={ log } responses={ responses } />;
};

const LogDetail = ( { log }: Props ) => {
  return (
    <div>
      {log._logType === 'action' && <ActionLogDetailView selectedLog={ log }/>}
      {log._logType === 'model' && <ModelLogDetailView selectedLog={ log } />}
      {log._logType === 'request' && <RequestLogDetail log={ log } />}
    </div>
  );
};

export default LogDetail;
